import { toggleFieldError } from "./toggleFieldError.js";

export function ConfirmEmailAddress(params, claim) {
    const email_address = document.getElementById("email_address");
    const confirm_email_address = document.getElementById(
        "confirm_email_address"
    );

    switch (params) {
        case "init":
            const handleEmailChange = () => {
                if (
                    confirm_email_address.value !== "" &&
                    email_address.value.toLowerCase() !==
                        confirm_email_address.value.toLowerCase()
                ) {
                    toggleFieldError(
                        confirm_email_address,
                        true,
                        "Does Not Match"
                    );
                } else {
                    toggleFieldError(confirm_email_address, false);
                }
            };

            email_address.addEventListener("change", handleEmailChange);
            confirm_email_address.addEventListener("change", handleEmailChange);
            break;

        case "process":
            if (
                claim.data.contact.email_address &&
                confirm_email_address.value.toLowerCase() !==
                    claim.data.contact.email_address.toLowerCase()
            ) {
                toggleFieldError(confirm_email_address, true, "Does Not Match");
                claim.flags.valid = false;
            } else {
                toggleFieldError(confirm_email_address, false);
            }
            break;
    }
}
